import { IAggregationData, IBaseDictItem, IBaseDiseaseInfo, IBaseTargetInfo, IQueryDataType, ISearchParams } from '@patsnap/synapse_common_interface'

export type IResearchDirectionChartAnalysisEntityType = 'TARGET_INDICATION' | 'TARGET_DRUG_TYPE' | 'DRUG_TYPE_INDICATION'

export interface IResearchDirectionChartParams extends ISearchParams {
  dimension: IResearchDirectionChartAnalysisEntityType
  expand_disease_id?: string
}

export interface IResearchDirectionChartResponse extends IAggregationData {
  target_list?: IBaseTargetInfo[]
  disease_list?: IBaseDiseaseInfo[]
  drug_type_list?: IBaseDictItem[]
}

export interface IResearchDirectionChartEntityItem {
  id: string
  name_cn: string
  name_en: string
  type: Extract<IQueryDataType, 'target' | 'disease' | 'drug_type'>
}

export const TRANSLATIONAL_MEDICINE_LIST_QUERY_KEY = 'translational-medicine-list'
